export default {
  namespaced: true,

  state: () => ({
    processing: false,

    cancelTokens: [],
  }),

  mutations: {
    start(state) {
      state.processing = true;
    },
    stop(state) {
      state.processing = false;
    },
    updateApiStatus(state, nextStatus) {
      state.processing = nextStatus;
    },

    addCancelToken(state, token) {
      state.cancelTokens.push(token);
    },

    deleteCancelToken(state, token) {
      const index = state.cancelTokens.findIndex(
        (cancelToken) => cancelToken.source.token === token
      );

      if (index > -1) {
        state.cancelTokens.splice(index, 1);
      }
    },

    clearCancelToken(state) {
      state.cancelTokens = [];
    },
  },

  actions: {
    cancelAllRequest({ commit, state }, message) {
      state.cancelTokens.forEach((token) => {
        if (token.source.cancel) {
          token.source.cancel(message);
        }
      });

      commit('clearCancelToken');
    },
  },

  getters: {
    isProcessing(state) {
      return state.processing;
    },

    hasCancelToken(state) {
      return state.cancelTokens.length > 0;
    },
  },
};
